import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { CustomMarkdown } from "../../../custom-markdown/custom-markdown";
import {
  dialogPaperStyles,
  dialogContentStyles,
  titleStyles,
  detailsTextStyles,
  optionsContainerStyles,
  optionItemStyles,
  optionKeyStyles,
  optionValueStyles,
  emptyOptionsTextStyles,
  dialogActionsStyles,
  cancelButtonStyles,
  okButtonStyles,
} from "./styles";

interface DetailsConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  detailsWindowText: string | null;
  selectedOptions: Record<string, string | undefined>;
}

export const DetailsConfirmationModal: React.FC<
  DetailsConfirmationModalProps
> = ({ open, onClose, onConfirm, detailsWindowText, selectedOptions }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: dialogPaperStyles(theme),
      }}
    >
      <DialogContent sx={dialogContentStyles(theme) as any}>
        {detailsWindowText ? (
          <Typography sx={detailsTextStyles(theme) as any}>
            <CustomMarkdown>{detailsWindowText}</CustomMarkdown>
          </Typography>
        ) : (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
              <CircularProgress size={18} />
              <Typography variant="body2" color="text.secondary">
                Waiting for details...
              </Typography>
            </Box>
            <Typography variant="h6" sx={titleStyles(theme) as any}>
              Here are the details of your role_playing session
            </Typography>

            <Box sx={optionsContainerStyles(theme) as any}>
              {Object.entries(selectedOptions).map(([key, value]) => (
                <Box key={key} sx={optionItemStyles(theme) as any}>
                  <Typography sx={optionKeyStyles(theme) as any}>
                    {key}:
                  </Typography>
                  <Typography sx={optionValueStyles(theme) as any}>
                    {value || "Not selected"}
                  </Typography>
                </Box>
              ))}
              {Object.keys(selectedOptions).length === 0 && (
                <Typography sx={emptyOptionsTextStyles(theme) as any}>
                  No options selected yet
                </Typography>
              )}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions sx={dialogActionsStyles(theme) as any}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={cancelButtonStyles(theme) as any}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={okButtonStyles}
          disabled={!detailsWindowText}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
